import { createSidekick } from '@connect/sidekick'
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

declare const connect: any;

@Injectable()
export class ConnectHelper {

    constructor(private authService: AuthService, private cookieService: CookieService) {
    }
    private subscription!: Subscription;
    public static readonly signout: string = 'connectsignout';

    public static flags: string = JSON.stringify({
        myCompanyManagerEnabled: true,
        profileEnabled: true,
        secureMessageEnabled: false,
        secureRecordEnabled: false,
        signUpEnabled: false,
        storeEnabled: true,
        supportEnabled: true,
        trackStatusEnabled: false
    });

    public initialize(): void {
        createSidekick();
    }

    public executeSignout(event: any): void {
        event.preventDefault();
        AuthService.clearKeepAliveInterval();
        this.subscription = this.authService.logoutUser().subscribe(() => {
            this.authService.clearStorageKeys();
            this.cookieService.delete(AuthService.userSessionKey);
            event.detail.resume();
        });
    }

    public activateSession(): void {
        let xbcSession: string = this.cookieService.get(AuthService.userSessionKey)!;
        if (xbcSession != null && xbcSession.trim() != '') 
        {
            connect.session.activate({
                interval: 1000 * 60 * 2,
                idleTimeout: 1000 * 60 * 15,
                sessionTimeout: 1000 * 60 * 60,
            });
        }
    }

    public signout():void{
        connect.signOut()
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

}